/* Extracted from sections/cart-drawer.liquid (inline script).
   #CartDrawer is a fixed-ID singleton in overlay-group. The document-level
   cart listeners are re-scoped through an AbortController so a theme-editor
   section reload rebinds them to the fresh drawer instead of stacking
   copies bound to the detached one (the inline original stacked them). */

var cartDrawerAbort = null;

function initCartDrawer() {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  if (cartDrawerAbort) cartDrawerAbort.abort();
  cartDrawerAbort = new AbortController();
  var listenerOpts = { signal: cartDrawerAbort.signal };
  var fetchTimer = null;

  /* Keep suggestions in sync with the cart: the section markup excludes
     products already in the cart (server-side), so after every cart change
     we re-fetch the section and swap just this region. */
  function refreshSuggestions() {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-suggestions]');
          var current = drawer.querySelector('[data-cart-suggestions]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }, 250);
  }

  function syncFromServer() {
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof drawer.render === 'function') drawer.render(cart);
        refreshSuggestions();
      })
      .catch(function () {});
  }

  /* One-tap add from the suggestion list (delegated — the list re-renders). */
  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-suggest-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-suggest-add'), 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { syncFromServer(); })
      .catch(function () { btn.disabled = false; });
  }, listenerOpts);

  /* Cart changed elsewhere (drawer quantity controls, section quick-adds). */
  document.addEventListener('cart:updated', refreshSuggestions, listenerOpts);
  document.addEventListener('cart:refresh', syncFromServer, listenerOpts);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartDrawer);
} else {
  initCartDrawer();
}
document.addEventListener('shopify:section:load', function (event) {
  if (event.target && event.target.querySelector && event.target.querySelector('#CartDrawer')) initCartDrawer();
});
